<template>
  <div class="cancelMemberEntry" @click="goMemeberList">
    <div class="text">{{ $t('FoodC_cancellation_ulUw_bpyg' /*管理其他国家会员*/) }}</div>
    <div class="icon"><img src="@/assets/images/member/pay_arrow_right.png" /></div>
  </div>
</template>

<script>
export default {
  methods: {
    goMemeberList() {
      this.$router.push({
        path: '/member/memberList',
        query: {
          nativeWebUIType: 1,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.cancelMemberEntry {
  margin: 0 32px;
  border-radius: 40px;
  background: #f5f5f7;
  height: 128px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .text {
    font-family: DiDiSans-Pro-Medium;
    font-size: 32px;
    line-height: 40px;
    color: #0b0b0d;
    padding-left: 40px;
  }
  .icon {
    margin-left: 10px;
    width: 80px;
    height: 128px;
    display: flex;
    align-items: center;
    img {
      width: 40px;
      height: 40px;
    }
  }
}
</style>
